module.exports = __webpack_public_path__ + "img/infbg.8ff02742.jpg";